import { useEffect, useRef, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { demarrerAlarme, arreterAlarme } from '../services/alarme';

export function useReservationsEnAttente(uid) {
  const [count, setCount] = useState(0);
  const prevCountRef = useRef(null);
  const permissionAsked = useRef(false);

  useEffect(() => {
    if (!uid) return;

    // Demander la permission de notification une seule fois
    if (!permissionAsked.current && 'Notification' in window && Notification.permission === 'default') {
      permissionAsked.current = true;
      Notification.requestPermission();
    }

    const q = query(
      collection(db, 'reservations'),
      where('proprietaireId', '==', uid),
      where('statut', '==', 'en attente')
    );

    const unsub = onSnapshot(q, (snap) => {
      const newCount = snap.size;
      setCount(newCount);

      // Notifier si le nombre augmente (nouvelle réservation)
      if (prevCountRef.current !== null && newCount > prevCountRef.current) {
        const diff = newCount - prevCountRef.current;
        sendBrowserNotification(diff);
      }
      prevCountRef.current = newCount;

      // Sonnerie en boucle tant qu'il reste des réservations en attente —
      // s'arrête dès que le gérant confirme ou annule (statut change dans
      // la requête ci-dessus, ce qui redéclenche ce callback avec newCount à 0).
      if (newCount > 0) demarrerAlarme();
      else arreterAlarme();
    });

    return () => {
      unsub();
      arreterAlarme();
    };
  }, [uid]);

  return count;
}

function sendBrowserNotification(nb) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;

  try {
    const n = new Notification('ResiPro CI — Nouvelle réservation 🏠', {
      body: `Vous avez ${nb} nouvelle(s) réservation(s) en attente de confirmation.`,
      icon: '/favicon.png',
      badge: '/favicon.png',
      tag: 'reservation-attente',
      requireInteraction: true,
    });
    n.onclick = () => {
      window.focus();
      window.location.href = '/gerant/reservations';
      n.close();
    };
  } catch {}
}
